module.exports = __webpack_public_path__ + "static/media/ball-joints-red.41d6258e.svg";